type CaseType<K extends string> = {[T in K]: any} & {$case: K};

export function isCaseTypeCheck<K extends string>(
  key: K,
  kind?: CaseType<string>,
): kind is CaseType<K> {
  return kind != null && key in kind && kind.$case === key;
}
